/**
 * "Select the renamed / created / moved row" (S8 Task 8.10): a dialog or the unfinished-moves notice records the path
 * it produced for a tab; the tab's grid selects that row as soon as a listing shows it (the refresh after the mutation
 * is asynchronous) and consumes the intent. Keys are the grid's row keys — the Blob ref of the path, which is what a
 * Data Lake row carries (`storageItemRef`), so the same intent works in both views.
 */
import { create } from 'zustand';
import { blobViewOfHnsPath } from '../../../../core/engines/azureStorageHnsPaths';
import { storageResourceKey, type HnsPathRef } from '../../../../types/azureStorage';

type State = { byTab: Record<string, string>; request: (tabId: string, key: string) => void; consume: (tabId: string) => void };

export const useHnsSelectionIntent = create<State>((set) => ({
  byTab: {},
  request: (tabId, key) => set((state) => ({ byTab: { ...state.byTab, [tabId]: key } })),
  consume: (tabId) => set((state) => {
    if (!(tabId in state.byTab)) return state;
    const byTab = { ...state.byTab };
    delete byTab[tabId];
    return { byTab };
  }),
}));

/** The grid row key of a Data Lake path. */
export const hnsRowKeyOf = (resource: HnsPathRef): string => storageResourceKey(blobViewOfHnsPath(resource));

export function requestHnsRowSelection(tabId: string | undefined, resource: HnsPathRef): void {
  if (tabId && resource.path !== '') useHnsSelectionIntent.getState().request(tabId, hnsRowKeyOf(resource));
}
